<template>
  <header
    class="header"
    :class="{ 'header--variant' : variant, [`header--variant--${variant}`] : variant }"
  >
    <PageTitle>
      <slot />
    </PageTitle>
  </header>
</template>

<script>
  import PageTitle from './PageTitle.vue'

  export default {
    components: {
      PageTitle,
    },

    props: {
      variant: { type: String, default: null }
    }
  }
</script>

<style lang="scss" scoped>
  .header {
    margin-bottom: 1.875rem;

    &--variant {
      padding: 30px 15px;
      text-align: center;
      border-bottom: 2px solid #000;

      &--gray {
        color: lighten(#000, 15%);
        background: #f2f2f2;
        border-color: darken(#f2f2f2, 5%); 
      }
    }
  }
</style>